import Vue from "vue";
import VueI18n from 'vue-i18n'  // 新增导入
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false;
import infiniteScroll from 'vue-infinite-scroll' 
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import VueCropper from 'vue-cropper'
import VueLazyload from 'vue-lazyload'

Vue.use(VueCropper)
Vue.use(VueViewer)
Vue.use(infiniteScroll)
Vue.use(ElementUI);
Vue.use(VueI18n)  // 新增i18n插件注册
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/error.png'),
  loading: require('@/assets/loading.gif'),
  attempt: 1
})

// 新增i18n实例配置
const i18n = new VueI18n({
  locale: 'en-US', // 默认中文
  messages: {
    'zh-CN': require('./lang/zh-CN').default,
    'en-US': require('./lang/en-US').default
  }
})

new Vue({
  router,
  store,
  i18n,  // 注入i18n实例
  render: (h) => h(App),
}).$mount("#app");
